
import Vue from "vue";
import RULES from "@/mixins/rules";
import EventBus from "@/plugins/event-bus";

export default Vue.extend({
  name: 'MultaZofemat',
  mixins: [RULES],
  directives: {},
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    externalId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
  }),
  created() {
  },
  mounted() {
  },
  computed: {},
  watch: {
  },
  methods: {
    close() {
      EventBus.$emit("close-multa-zofemat");
    },
  }
});

